import type { Filter, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes';

export const FilterMultiSelectPill = (filter: Filter): string[] => {
  const data = filter.data as FilterDataMultiSelect;
  const selected = data.options.filter((o) => o.selected && !o.isDefault);
  // Use data.label if present, otherwise fallback to empty string
  return selected.length === 0 ? [data.label ?? ''] : selected.map((o) => o.label);
};
